import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns } from "./datatablesource";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  updateDoc, // Import updateDoc to update the trending field
} from "firebase/firestore";
import { db } from "../../firebase";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import Switch from "@mui/material/Switch"; // Import MUI Switch

const Datatable = () => {
  const [data, setData] = useState([]);
  const [idToDelete, setIdToDelete] = useState("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(
      collection(db, "symptoms"),
      (snapShot) => {
        let list = [];
        snapShot.docs.forEach((doc) => {
          list.push({ id: doc.id, ...doc.data() });
        });
        setData(list);
      },
      (error) => {
        console.log(error);
      }
    );

    return () => {
      unsub();
    };
  }, []);

  const handleDeleteClick = (id) => {
    setIdToDelete(id);
    setOpen(true); // Open the dialog
  };

  const handleClose = () => {
    setOpen(false);
    setIdToDelete("");
  };

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(db, "symptoms", idToDelete)); // Correct collection
      setData(data.filter((item) => item.id !== idToDelete));
    } catch (err) {
      console.log(err);
    } finally {
      handleClose();
    }
  };

  const handleToggleTrending = async (id, currentValue) => {
    try {
      // Update the trending status in Firestore
      await updateDoc(doc(db, "symptoms", id), {
        trending: !currentValue,
      });

      // Update local state
      setData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, trending: !currentValue } : item
        )
      );
    } catch (err) {
      console.log(err);
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
          <Link
            to={`/symptoms/fullview?uid=${params.row.id}`}
            style={{ textDecoration: "none" }}
          >
            <div className="viewButton">View</div>
          </Link>
          <div
            className="deleteButton"
            onClick={() => handleDeleteClick(params.row.id)} // Trigger delete modal
          >
            Delete
          </div>
          <Switch
            checked={params.row.trending} // Switch state based on trending field
            onChange={() => handleToggleTrending(params.row.id, params.row.trending)} // Toggle trending
            name="trending"
          />
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      <div className="datatableTitle">
        Symptoms
        <Link to="/symptoms/new" className="link">
          Add New
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />

      {/* Confirmation Dialog */}
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this document? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Datatable;
